import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=822bd566&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderHistory.vue?vue&type=style&index=0&id=822bd566&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "822bd566",
  "34a95592"
  
)

export default component.exports